import { useSelector } from 'react-redux'

import FeatureToggle from '~/constants/featureToggle'
import { getCurrentBusinessIsOmniChannel } from '~/store/reducers/auth'
import { getFeatureToggle } from '~/store/reducers/constants'
import { getIsFinalized } from '~/store/reducers/soap'

export const useSoapMenuReportCard = () => {
  const isCurrentBusinessIsOmniChannel = useSelector(
    getCurrentBusinessIsOmniChannel,
  )
  const isFinalized = useSelector(getIsFinalized)
  const filterUnfinalizedForCvcFT = useSelector(
    getFeatureToggle(
      FeatureToggle.FILTER_UNFINALIZED_SOAP_FROM_MEDICAL_RECORDS,
    ),
  )

  return {
    showReportCard:
      !isCurrentBusinessIsOmniChannel ||
      !filterUnfinalizedForCvcFT ||
      isFinalized,
  }
}
